import { EnhancedRouteProps } from 'router/routes/Enhanced/Enhanced.route';
import ManagePeople from './pages/ManagePeople';
import EditEnterprise from './pages/EditEnterprise';

export default [
  {
    path: 'manage-people',
    element: ManagePeople,
  },
  {
    index: true,
    element: EditEnterprise,
  },
] as Array<EnhancedRouteProps>;
